import { ApplicationRef, computed, inject, Injectable, signal } from '@angular/core';

import { PanelActions, PanelData } from '@connect-services/client/models/panel.model';
import {
    ContentLayoutService,
    HORIZONTAL_HOME_GRID_PARAMS,
    PUZZLE_1_3_HOME_GRID_PARAMS,
    VERTICAL_HOME_GRID_PARAMS,
} from '@connect-services/client/services/content-layout.service';

@Injectable({
    providedIn: 'root',
})
export class PanelService {
    public readonly currentPanel = signal<PanelActions | null>(null);
    public readonly data = signal<PanelData | null>(null);
    public readonly expanded = computed<boolean>(() =>
        [
            VERTICAL_HOME_GRID_PARAMS.ONE_THIRD_VERTICAL,
            PUZZLE_1_3_HOME_GRID_PARAMS.ONE_THIRD_VERTICAL,
            HORIZONTAL_HOME_GRID_PARAMS.ONE_THIRD_HORIZONTAL,
            HORIZONTAL_HOME_GRID_PARAMS.TWO_THIRDS_HORIZONTAL,
        ].includes(this.contentLayoutService.mapSizeType()),
    );
    public readonly isPanelOpen = computed<boolean>(() => this.currentPanel() !== null);

    private readonly applicationRef = inject(ApplicationRef);
    private readonly contentLayoutService = inject(ContentLayoutService);

    public closePanel(): void {
        this.currentPanel.set(null);
        this.data.set(null);
    }

    public setPanel(action: PanelActions | null, data?: PanelData | null): void {
        // refresh panel if it already has data
        if (this.data()) {
            this.closePanel();
            this.applicationRef.tick();
        }

        this.currentPanel.set(action);
        if (data !== undefined) {
            this.data.set(data);
        }
    }
}
